import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import dotenv from "dotenv"
import * as urls from "../../helpers/url_helper"

dotenv.config()
const url = process.env.LOCALHOST
  ? process.env.LOCALHOST
  : "https://qa_api_gtc.amerck.com"

export const customerAPI = createApi({
  reducerPath: "customerApi",
  baseQuery: fetchBaseQuery({ baseUrl: url, timeout: 10000 }),
  endpoints: builder => ({
    getCustomers: builder.query({
      query: () => ({
        url: urls._GET_NEW_CUSTOMERS,
        // url: '/source-files/get-uploaded-batch',
        method: "GET",
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
        timeout: 15000,
      }),
    }),
    
    getTestNodeContacts: builder.query({
      query: ({ customer_id, operator_id }) => ({
        url: urls._GET_TEST_NODE_CONTACTS,
        method: "GET",
        params: {
          customer_id,
          operator_id
        },
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
        timeout: 15000,
      }),
    }),
    getCustomersByOperator: builder.query({
      query: (operator_id) => ({
        url: `${urls._GET_CUSTOMERS_BY_OPERATOR}/${operator_id}`,
        method: "GET",
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
        timeout: 15000,
      }),
    }),
    getSmscReceivers: builder.query({
      query: ({ customer_id, operator_id }) => ({
        url: urls._GET_SMSC_RECEIVERS,
        method: "GET",
        params: {
          customer_id,
          operator_id
        },
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
        timeout: 15000,
      }),
    }),
  }),
})

export const { 
  useGetCustomersQuery,
  useGetTestNodeContactsQuery,
  useLazyGetTestNodeContactsQuery,
  useLazyGetCustomersByOperatorQuery,
  useLazyGetSmscReceiversQuery
} = customerAPI
